export default "__VITE_ASSET__8229913e__"